import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ComprobantesDelegadoLayer from "../../components/comprobantes/ComprobantesDelegadoLayer";

const ComprobantesDelegado = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Comprobantes Delegado"/>

        {/* RoleAccessLayer */}
        <ComprobantesDelegadoLayer/>

      </MasterLayout>

    </>
  );
};

export default ComprobantesDelegado; 
